export default (num) => typeof num === "number" ? `$${num.toFixed(2)}` : null;
